/** Shared by employee and unassigned roster rows so the two can't drift apart on what is locked. */
export function isDayReadonly(
    date: string,
    { today, commitBefore, canEditPast }: { today: string; commitBefore?: string | null; canEditPast: boolean }
) {
    return (!!commitBefore && date < commitBefore) || (date < today && !canEditPast);
}
